<div class="panel-header">
	<div class="column title">
		<h2>Afwezigheidsredenen</h2>
		<div class="subtitle">{{ maandDropdownState.getMaandMetJaar(schooljaar()) }}</div>
	</div>
	<div class="column" data-princexml-ignore data-html2canvas-ignore>
		<app-single-select-dropdown
			class="select-maand"
			[opties]="maandDropdownState.opties()"
			[selectedOptie]="maandDropdownState.selectedOptie()"
			(onOptieClicked)="maandDropdownState.setMaand($event)"
		></app-single-select-dropdown>
	</div>
	<div class="column" data-princexml-ignore data-html2canvas-ignore>
		<app-icon name="info" color="primary-1" hoverColor="primary-2" size="small" [appTooltip]="redenenInfo"></app-icon>
	</div>
	<ng-template #redenenInfo>
		<div class="tooltip">
			<h4>Afwezigheidsredenen</h4>
			<p>
				Toont alle geregistreerde afwezigheidsredenen van de geselecteerde leerlingen binnen het gekozen schooljaar en het gekozen tijdsvak.
			</p>
		</div>
	</ng-template>
</div>
<div class="panel-content">
	@if (!loading()) {
		@if (redenenModel(); as model) {
			<app-table
				[model]="model"
				class="redenen-table full-width"
				[sortActive]="sortOrder().active"
				[sortDirection]="sortOrder().direction"
				(rowClick)="rowClicked($event)"
			></app-table>
		} @else {
			<div>De huidige selectie levert geen resultaten op.</div>
		}
	} @else if (spinnerDelay | async) {
		<app-css-spinner></app-css-spinner>
	}
</div>
